import styled from 'styled-components';

export const StatusWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 2rem;

  h3 {
    font-size: min(4.5vw, 1.8rem);
  }
`;
